import { render, staticRenderFns } from "./Electionformstep.vue?vue&type=template&id=b742db0e&scoped=true"
import script from "./Electionformstep.vue?vue&type=script&lang=js"
export * from "./Electionformstep.vue?vue&type=script&lang=js"
import style0 from "./Electionformstep.vue?vue&type=style&index=0&id=b742db0e&prod&scoped=true&lang=css"
import style1 from "./Electionformstep.vue?vue&type=style&index=1&id=b742db0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b742db0e",
  null
  
)

export default component.exports